import React, { useEffect, useState } from "react";
import { useField } from "formik";

// Create a check box with error detection using Formik hooks
export const GeneralCheckBox = ({ children, ...props }) => {
    const [field, meta] = useField({ ...props, type: "checkbox" });

    const [validationCheck, setValidationCheck] = useState("");

    // Sets up bootstrap validation styling
    useEffect(() => {
        if (meta.touched && meta.error) {
            setValidationCheck("is-invalid");
        } else if (meta.touched && !meta.error) {
            setValidationCheck("is-valid");
        }
    }, [meta.touched, meta.error]);

    return (
        <>
            <input
                className={"form-check-input" + " " + validationCheck}
                type="checkbox"
                {...field}
                {...props}
                aria-invalid={meta.touched && meta.error ? "true" : null}
                aria-describedby={meta.touched && meta.error ? field.name + "-error" : ""}

            />
            <label aria-hidden="true" className="form-label">{children}</label>
            {meta.touched && meta.error ? (
                <div aria-hidden="true" className="invalid-feedback" id={field.name + "-error"} >{meta.error}</div>
            ) : null}
        </>
    );
};
